import { render, staticRenderFns } from "./MalariaRdtResult.vue?vue&type=template&id=48b21f01&scoped=true"
import script from "./MalariaRdtResult.vue?vue&type=script&lang=js"
export * from "./MalariaRdtResult.vue?vue&type=script&lang=js"
import style0 from "./MalariaRdtResult.vue?vue&type=style&index=0&id=48b21f01&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b21f01",
  null
  
)

export default component.exports